var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { Field, Form, reduxForm, } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import SelectField from '../../../shared/util/SelectField';
const validate = (node) => {
    let errors = {};
    if (!node)
        errors;
    if (!node.payload ||
        !node.payload.queue ||
        !node.payload.queue.value ||
        node.payload.queue.value === '') {
        errors = {
            payload: {
                queue: {
                    value: 'Required - please select a queue',
                },
            },
        };
    }
    return errors;
};
class ContactFormModal extends PureComponent {
    handleSaveClick(values) {
        var _a, _b;
        let selectedQueue;
        if ((_b = (_a = values.payload) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.value) {
            const matchingQueue = this.props.queuesState.queues.find((queue) => queue.id === values.payload.queue.value);
            if (matchingQueue) {
                selectedQueue = {
                    value: matchingQueue.id,
                    label: matchingQueue.name,
                };
            }
        }
        const payload = {
            queue: selectedQueue,
        };
        if (values.payload.fromEmail) {
            payload.fromEmail = values.payload.fromEmail;
        }
        const nodeOptionsText = `Contact Form ${selectedQueue.label ? `(${selectedQueue.label})` : ''}`;
        const nodeOptions = Object.assign(Object.assign(Object.assign({}, this.props.node), values), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.CONTACT_FORM, overlay: [], payload, text: nodeOptionsText });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    closeModal() {
        const { destroy, triggerClose } = this.props;
        destroy();
        triggerClose();
    }
    render() {
        const { fromEmails, handleSubmit, node, nodeLabel, queuesState, dirty: isChanged, } = this.props;
        const listQueues = (queue) => {
            return (_jsx("option", Object.assign({ value: queue.id }, { children: queue.name }), queue.id));
        };
        const listFromMails = (fromEmail, index) => {
            const fromEmailAddress = fromEmail.spf_sender_email !== undefined &&
                fromEmail.spf_sender_email !== null &&
                typeof fromEmail.spf_sender_email === 'string'
                ? fromEmail.spf_sender_email
                : fromEmail.email_address;
            const label = fromEmail.sender_name !== undefined && fromEmail.sender_name !== null
                ? `${fromEmail.sender_name} <${fromEmailAddress}>`
                : fromEmailAddress;
            return (_jsx("option", Object.assign({ value: fromEmail.email_address }, { children: label }), index));
        };
        return (_jsx("div", Object.assign({ className: "contact-form modal-chatflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, { title: nodeLabel, onClose: this.closeModal }), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column" }, { children: [_jsxs(Field, Object.assign({ displayName: "Queue", required: true, name: "payload.queue.value", className: "form-control", component: SelectField }, { children: [_jsxs("option", Object.assign({ hidden: true, value: "" }, { children: [' ', "- Please select a queue"] })), queuesState.queues
                                            .filter((queue) => {
                                            var _a, _b;
                                            return queue.id === ((_b = (_a = node.payload) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.value) ||
                                                !queue.is_archived;
                                        })
                                            .map(listQueues)] })), _jsxs(Field, Object.assign({ displayName: "Email", name: "payload.fromEmail", className: "form-control mb0", component: SelectField }, { children: [_jsx("option", Object.assign({ value: "" }, { children: " - Select a from email" })), fromEmails.map(listFromMails)] }))] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], ContactFormModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], ContactFormModal.prototype, "closeModal", null);
export default reduxForm({
    form: 'chatFlowContactForm',
    enableReinitialize: true,
    validate,
})(ContactFormModal);
